import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { tabsContent, tabsTrigger } from "@/utils/StoreManagementTabs";
import React from "react";

const ManageInventory = () => {
  return (
    <div className="container  py-12 px-8 md:px-6 md:max-w-[90rem] h-full">
      <Tabs defaultValue="products" className="">
        <TabsList className="grid w-[400px] grid-cols-3">
          {tabsTrigger?.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value} className="w-full">
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {tabsContent?.map((content) => (
          <TabsContent key={content.value} value={content.value} className="py-4">
            {content.element}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};

export default ManageInventory;
